import { useEffect, useRef } from "react";

const FloatingParticles = ({ color1 = "rgba(99, 179, 237, 0.3)", color2 = "rgba(190, 227, 248, 0.45)", count = 100 }) => {
    const canvasRef = useRef(null);
    const particles = useRef([]);
    const mouse = useRef({ x: 0, y: 0 });

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        let animationFrameId;

        const handleResize = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };

        const createParticles = () => {
            particles.current = [];
            for (let i = 0; i < count; i++) {
                particles.current.push({
                    x: Math.random() * canvas.width,
                    y: Math.random() * canvas.height,
                    size: Math.random() * (i % 5 === 0 ? 12 : 4) + 1,
                    speedX: (Math.random() - 0.5) * 0.7,
                    speedY: (Math.random() - 0.5) * 0.7,
                    color: i % 5 === 0 ? color1 : color2,
                    type: i % 10 === 0 ? "flower" : "dot"
                });
            }
        };

        const handleMouseMove = (e) => {
            mouse.current.x = e.clientX;
            mouse.current.y = e.clientY;
        };

        const drawFlowerSymbol = (ctx, x, y, size, color) => {
            ctx.beginPath();
            ctx.fillStyle = color;
            for (let i = 0; i < 5; i++) {
                const angle = (i * 2 * Math.PI) / 5;
                const px = x + Math.cos(angle) * (size / 2);
                const py = y + Math.sin(angle) * (size / 2);
                ctx.moveTo(px, py);
                ctx.arc(px, py, size / 3, 0, Math.PI * 2);
            }
            ctx.fill();
        };

        const animate = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            particles.current.forEach((p) => {
                p.x += p.speedX; p.y += p.speedY;
                if (p.x < 0 || p.x > canvas.width) p.speedX *= -1;
                if (p.y < 0 || p.y > canvas.height) p.speedY *= -1;
                
                const dx = p.x - mouse.current.x;
                const dy = p.y - mouse.current.y;
                const dist = Math.sqrt(dx * dx + dy * dy);
                if (dist < 150) { 
                    p.x += dx * 0.02; 
                    p.y += dy * 0.02; 
                }
                
                if (p.type === "flower") drawFlowerSymbol(ctx, p.x, p.y, p.size, p.color);
                else {
                    ctx.beginPath(); 
                    ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
                    ctx.fillStyle = p.color; 
                    ctx.fill();
                }
            });
            animationFrameId = requestAnimationFrame(animate);
        };

        window.addEventListener("resize", handleResize);
        window.addEventListener("mousemove", handleMouseMove);
        handleResize(); 
        createParticles(); 
        animate();
        
        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("mousemove", handleMouseMove);
            cancelAnimationFrame(animationFrameId);
        };
    }, [color1, color2, count]);

    return (
        <canvas 
            ref={canvasRef} 
            style={{ 
                position: "fixed", 
                inset: 0, 
                zIndex: 0, 
                pointerEvents: "none" 
            }} 
        />
    );
};

export default FloatingParticles;
